module.exports = __webpack_public_path__ + "img/dkj.9d6a4301.png";